"use client";
import Link from "next/link";
import Image from "next/image";
import { useState, useEffect, useRef } from "react";
import logo from "../../public/aiproperty-logo.png";
import SignUpModal from "../components/SignUpModal";
import menu from "../../public/menu.svg";
import user from "../../public/user-login.svg";
import LoginModal from "./LoginModal";
import cross from "../../public/cross.svg";
import crop from "../../public/aiproperty-logo.png";
import profile2 from "../../public/profile3.png";
import heart from "../../public/heart.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/lib/redux/store";
import { logout } from "@/lib/redux/slice/authSlice";
import { ProfileSettingsModal } from "./ProfileSettingModal";
import { Root } from "postcss";
import { useRouter } from "next/navigation";
import cookie from "js-cookie";
import { toast } from "react-toastify"; // <-- 1. IMPORT TOAST

// NEW: helper
import { getImageSrc } from "@/lib/getImageSrc";
import DistrictsNavDropdown from "@/components/DistrictsNavDropdown";
import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_NUMBER } from "@/lib/v2/constants";

export default function Header() {
  const router = useRouter();
  const dispatch = useDispatch<AppDispatch>();
  const token = cookie.get("token");
  // const token = useSelector((state: RootState) => state.auth.token);
  const userData = useSelector((state: RootState) => state.auth.user);
  const modalRef = useRef<HTMLDivElement>(null); // Add ref for modal content
  const [screenSize, setScreenSize] = useState("desktop");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const { isPopupOpen } = useSelector((state: RootState) => state.popup);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setScreenSize("mobile");
      } else if (window.innerWidth < 1100) {
        setScreenSize("tablet");
      } else {
        setScreenSize("desktop");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const openSignUpModal = () => {
    setIsSignUpModalOpen(true);
    setIsMenuOpen(false); // <-- 2. FIX: Close side menu
  };

  const closeSignUpModal = () => {
    setIsSignUpModalOpen(false);
  };

  const openLoginModal = () => {
    setIsLoginModalOpen(true);
    setIsMenuOpen(false); // <-- 3. FIX: Close side menu
  };

  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
  };
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = () => {
    setIsOpen(false);
  };

  const navLinks = [
    { href: "/new-launches", label: "New launches" },
    { href: "/3d-navigator", label: "AIProp 3D" },
    { href: "/compare", label: "Compare" },
    { href: "/valuation", label: "Valuation" },
    { href: "/mortgage-calculator", label: "Calculators" },
    { href: "/blog", label: "Blog" },
    { href: "/about", label: "About" },
    // { href: "/project", label: "Projects" },
    // { href: "/home-loans", label: "Home Loans" },
    // { href: "/faq", label: "FAQ" },
    // { href: "/contact", label: "Contact" },
    // { href: "/affordability-calculator", label: "Affordability  Analysis" },
  ];

  // --- 4. THIS IS THE FIXED FUNCTION ---
  const handleLogout = () => {
    cookie.remove("token");
    dispatch(logout());
    toast.success("Signed out successfully!"); // <-- FIX: Added message
    router.push("/"); // <-- FIX: Added redirect
  };

  const toggleProfileModal = () => {
    setIsProfileModalOpen(!isProfileModalOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false); // Close the modal when clicking outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    router.push("/collection");
  };

  // NEW: compute user image src safely
  const userImageSrc = getImageSrc(userData?.images?.[0]?.path);
  const userImageIsExternal = !!userImageSrc && /^https?:\/\//i.test(userImageSrc);

  return (
    <>
      {/*
        z-40: must sit above in-page sticky elements like the price-list
        table header (z-20) so the districts dropdown can hover over the
        table when scrolled. Still below modals (z-[999]). When the
        side-popup is open we drop to z-0 so the popup overlay covers
        the nav as before — that behaviour is unchanged.
      */}
      <header
        className={`bg-white border-b border-line sticky top-0 z-40  ${
          isPopupOpen ? "z-0" : ""
        }`}
      >
        <div className="mx-auto max-w-site md:px-8 px-4">
          <div className="flex items-center justify-between h-20">
            <Link href="/" className="flex items-center">
              {/* priority: the logo is above the fold on every page —
                  without it Next lazy-loads it, which can leave the
                  header logo blank until hydration settles. */}
              <Image
                className="custom-logo-width"
                src={logo}
                alt="AI Property"
                priority
              />
            </Link>
            {screenSize === "mobile" ? (
              <div className="flex items-center">
                {!token ? (
                  <>
                    <a
                      href={`https://wa.me/${WHATSAPP_NUMBER}`}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="WhatsApp Winnie"
                      className="mr-3 inline-flex size-9 items-center justify-center rounded-full bg-whatsapp text-white"
                    >
                      <FaWhatsapp aria-hidden="true" className="size-4" />
                    </a>
                    <button
                      className="text-gray-600 hover:text-gray-900 mr-2"
                      onClick={openLoginModal}
                    >
                      <Image src={user} alt="" />
                    </button>
                  </>
                ) : (
                  <>
                    <button className="text-black text-sm font-medium mr-2">
                      <span onClick={handleLogout}>Sign Out</span>
                    </button>
                    <button
                      className="text-gray-600 hover:text-gray-900 mr-4"
                      onClick={handleClick}
                    >
                      <Image
                        src={heart}
                        alt=""
                        className="rounded-full"
                        width={30}
                        height={30}
                      />
                    </button>
                    <button
                      className="text-gray-600 hover:text-gray-900 mr-2"
                      onClick={toggleProfileModal}
                    >
                      <Image
                        // src={profile}
                        src={
                          // use safe src (getImageSrc) and fallback to local image
                          userImageSrc ? userImageSrc : profile2
                        }
                        alt=""
                        className="rounded-full"
                        width={30}
                        height={30}
                        unoptimized={userImageIsExternal}
                      />
                    </button>
                  </>
                )}
                <button
                  className="text-gray-600 hover:text-gray-900"
                  onClick={toggleMenu}
                >
                  {isMenuOpen ? (
                    <Image src={cross} alt="" />
                  ) : (
                    <Image src={menu} alt="" />
                  )}
                </button>
              </div>
            ) : screenSize === "tablet" ? (
              <div className="flex items-center">
                <nav className="flex space-x-4 mr-4">
                  {navLinks.slice(0, 3).map((link) => (
                    <Link
                      key={link.href}
                      href={link.href}
                      className="text-black text-[18px] hover:text-[#0094FF]"
                    >
                      {link.label}
                    </Link>
                  ))}
                </nav>
                {!token ? (
                  <button
                    onClick={openSignUpModal}
                    className="text-[#0094FF] hover:text-[#0080E0] font-medium mr-4"
                  >
                    Sign Up
                  </button>
                ) : (
                  <>
                    <button className="mr-4" onClick={handleClick}>
                      <Image
                        src={heart}
                        alt=""
                        className="rounded-full"
                        width={30}
                        height={30}
                      />
                    </button>
                    <button className="text-black text-sm font-medium mr-4">
                      <span onClick={handleLogout}>Sign Out</span>
                    </button>
                  </>
                )}

                <button
                  className="text-gray-600 hover:text-gray-900"
                  onClick={toggleMenu}
                >
                  <Image src={menu} alt="" />
                </button>
              </div>
            ) : (
              <>
                <nav className="hidden lg:flex items-center gap-7 text-[15px] font-medium text-ink-muted">
                  {navLinks.slice(0, 1).map((link) => (
                    <Link
                      key={link.href}
                      href={link.href}
                      className="hover:text-ink"
                    >
                      {link.label}
                    </Link>
                  ))}
                  <DistrictsNavDropdown mode="desktop" />
                  {navLinks.slice(1).map((link) => (
                    <Link
                      key={link.href}
                      href={link.href}
                      className="hover:text-ink"
                    >
                      {link.label}
                    </Link>
                  ))}
                </nav>
                <div className="hidden lg:flex items-center gap-3 text-[15px]">
                  {!token ? (
                    <>
                      <button
                        onClick={openLoginModal}
                        className="rounded-full px-3 py-2 font-medium text-ink-muted hover:bg-surface hover:text-ink"
                      >
                        Sign in
                      </button>
                      <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex min-h-9 items-center gap-2 rounded-full bg-whatsapp px-4 py-2 text-sm font-semibold text-white hover:bg-[#20BD5A]"
                      >
                        <FaWhatsapp aria-hidden="true" className="size-4" />
                        WhatsApp Winnie
                      </a>
                    </>
                  ) : (
                    <>
                      <button className="mr-4" onClick={handleClick}>
                        <Image
                          src={heart}
                          alt=""
                          className="rounded-full"
                          width={30}
                          height={30}
                        />
                      </button>
                      <button className="text-black text-sm font-medium mr-4">
                        <span onClick={handleLogout}>Sign Out</span>
                      </button>
                    </>
                  )}

                  {token && (
                    <div
                      className="relative inline-block text-left"
                      ref={modalRef}
                    >
                      <button
                        className="text-gray-600 hover:text-gray-900 mr-4 focus:outline-none flex justify-center items-center"
                        onClick={toggleDropdown}
                      >
                        <Image
                          // src={profile}
                          src={
                            userImageSrc ? userImageSrc : profile2
                          }
                          alt="Profile"
                          className="rounded-full w-[30px] h-[30px] object-contain bg-white outline outline-[#0094FF]"
                          width={30}
                          height={30}
                          unoptimized={userImageIsExternal}
                        />
                      </button>
                      {isOpen && (
                        <div
                          className="absolute right-0 mt-2 w-44 bg-white rounded-[20px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
                          onClick={handleOptionClick}
                        >
                          <div className="px-4 py-2">
                            <p className="text-[#0094FF] font-medium text-[16px]">
                              {userData?.name}
                            </p>
                            <hr className="my-1" />
                          </div>
                          <ul
                            className="py-1 overflow-hidden"
                            onClick={toggleProfileModal}
                          >
                            <li className="px-4 py-3 rounded-[20px] hover:bg-gray-100 cursor-pointer">
                              Profile
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Off-canvas Menu for Mobile and Tablet */}
        <div
          className={`fixed inset-0 bg-black bg-opacity-50  transition-all duration-300 ${
            isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
          onClick={toggleMenu}
        ></div>
        <div
          className={`fixed top-0 right-0 h-full w-64 bg-white shadow-lg z-30 transition-transform duration-300 ${
            isMenuOpen
              ? "transform translate-x-0"
              : "transform translate-x-full"
          }`}
        >
          <div className="flex justify-between items-center p-4">
            <Image
              src={crop}
              alt="Logo"
              className="w-[90px]"
              width={40}
              height={40}
            />
            <button onClick={toggleMenu}>
              <Image src={cross} alt="Close" />
            </button>
          </div>

          <div className="p-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="block py-2 text-gray-600 hover:text-gray-900"
                onClick={toggleMenu}
              >
                {link.label}
              </Link>
            ))}
            <DistrictsNavDropdown mode="mobile" onNavigate={toggleMenu} />
            {!token ? (
              <>
                <button
                  onClick={openSignUpModal}
                  className="block py-2 px-4 w-full text-center bg-[#0094FF] text-white font-medium rounded-md"
                >
                  Sign Up
                </button>
                <button
                  onClick={openLoginModal}
                  className="block py-2 px-4 w-full text-center bg-[#0094FF] text-white font-medium rounded-md mt-2"
                >
                  Sign In
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={handleLogout}
                  className="block py-2 px-4 w-full text-center text-black font-medium rounded-md"
                >
                  Sign Out
                </button>
              </>
            )}
          </div>
        </div>
      </header>

      {/* SignUp and Login Modals */}
      <SignUpModal
        isOpen={isSignUpModalOpen}
        onClose={closeSignUpModal}
        setIsLoginModalOpen={setIsLoginModalOpen}
      />
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={closeLoginModal}
        setIsSignUpModalOpen={setIsSignUpModalOpen}
      />

      <ProfileSettingsModal
        isOpen={isProfileModalOpen}
        onClose={toggleProfileModal}
      />
    </>
  );
}